// @ts-strict-ignore
import React from 'react'
import { useSetAtom } from 'jotai'
import { useGetCryptoMassPayoutList } from 'hooks/queries/MassPayouts/useGetCryptoMassPayoutsList'
import { useGetMassFiatPayoutsListQuery } from 'hooks/queries/MassPayouts/useGetMassFiatPayoutsList'
import { cryptoBatchListAtom, fiatBatchListAtom } from '../atoms/massPayoutAtoms'
import { MassPayoutBatchView } from './MassPayoutBatchView'

export const MassPayoutLanding = () => {
  const setCryptoBatchList = useSetAtom(cryptoBatchListAtom)
  const setFiatBatchList = useSetAtom(fiatBatchListAtom)

  const { data: cryptoBatchList, isPending: isFetchingCrypto } = useGetCryptoMassPayoutList()
  const { data: { content: fiatBatchList } = {}, isLoading: isFetchingFiat } =
    useGetMassFiatPayoutsListQuery({
      page: 0,
    })

  setCryptoBatchList(cryptoBatchList ?? [])
  setFiatBatchList(fiatBatchList)

  return <MassPayoutBatchView isFetching={isFetchingCrypto || isFetchingFiat} />
}
